import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum ClearanceApprovalRouteNames {
  CLEARANCE_APPROVAL_TABLE = "CLEARANCE_APPROVAL_TABLE",
  CLEARANCE_APPROVAL_DETAIL = "CLEARANCE_APPROVAL_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type ClearanceApproval = { clearanceApprovalId: string };
type Query = { query?: Record<string, string> };

export class ClearanceApprovalGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = ClearanceApprovalGoToHelper.locations;

    return {
      ClearanceApprovalTable: (partnerId: string) => {
        return {
          text: $t("clearanceApproval.clearanceApprovals").toString(),
          exact: true,
          to: locations.clearanceApprovalTable({ partnerId })
        };
      },
      ClearanceApprovalDetail: (partnerId: string, clearanceApprovalId: string) => {
        return {
          text: $t("common.nouns.detail").toString(),
          exact: true,
          to: locations.clearanceApprovalDetail({ partnerId, clearanceApprovalId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    clearanceApprovalTable: (d: Partner & Query) => {
      return {
        name: ClearanceApprovalRouteNames.CLEARANCE_APPROVAL_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    clearanceApprovalDetail: (d: Partner & ClearanceApproval & Query) => {
      return {
        name: ClearanceApprovalRouteNames.CLEARANCE_APPROVAL_DETAIL,
        params: { partnerId: d.partnerId, clearanceApprovalId: d.clearanceApprovalId },
        query: d.query
      };
    }
  };

  goToClearanceApprovalTable(d: Tab & Partner & Query) {
    this.go(ClearanceApprovalGoToHelper.locations.clearanceApprovalTable(d), d.newTab);
  }

  goToClearanceApprovalDetail(d: Tab & Partner & ClearanceApproval & Query) {
    this.go(ClearanceApprovalGoToHelper.locations.clearanceApprovalDetail(d), d.newTab);
  }
}
